(function() {
    'use strict';

    angular.module('holiday')
        .controller('HolidayListController', HolidayListController);

    HolidayListController.$inject = ['notificationSrvc', 'lodashService', 'holidayDataSrvc', 'holidaySrvc', 'holidayMessagesConst', 'holidayPermissionsConst', 'checkModelPermissionsSrvc', 'dateFormatConst', 'momentSrvc'];

    function HolidayListController(notificationSrvc, lodashService, holidayDataSrvc, holidaySrvc, holidayMessagesConst, holidayPermissionsConst, checkModelPermissionsSrvc, dateFormatConst, momentSrvc) {
        var self = this;

        self.eventSources = [{
            events: []
        }];

        self.uiConfig = {
            calendar: {
                height: 500,
                editable: false,
                firstDay: 1,
                header: {
                    left: 'month basicWeek basicDay agendaWeek agendaDay',
                    center: 'title',
                    right: 'today prev,next'
                },
                viewRender: getHolidays,
                dayClick: addEvent,
                eventClick: deleteHolidays
            }
        };

        function getHolidays() {
            holidayDataSrvc.list().$promise.then(
                function(response) {
                    response.forEach(function(val) {
                        self.eventSources[0].events.push({
                            id: val.pk,
                            start: momentSrvc.strToDate(val.holiday),
                        });
                    });
                }
            );
        }

        function addEvent(date) {
            var isEventHere;
            $('.calendar').fullCalendar('clientEvents', function(event) {
                if (event.start.format(dateFormatConst.momentDate) === date.format(dateFormatConst.momentDate)) {
                    isEventHere = true;
                }
            });

            if (!isEventHere) {
                addHoliday(date.format(dateFormatConst.momentDate));
            }
        }

        function addHoliday(date) {
            if (checkModelPermissionsSrvc.isDenied(holidayPermissionsConst.add)) {
                notificationSrvc.notification("error", holidayPermissionsConst.add.errorMsg);
                return;
            }

            holidayDataSrvc.create({
                holiday: date
            }).$promise.then(
                function(response) {
                    notificationSrvc.notification("success", holidayMessagesConst.add);
                    self.eventSources[0].events.push({
                        id: response.pk,
                        start: momentSrvc.strToDate(date),
                    });
                }
            );
        }

        function deleteHolidays(date) {
            if (checkModelPermissionsSrvc.isDenied(holidayPermissionsConst.delete)) {
                notificationSrvc.notification("error", holidayPermissionsConst.delete.errorMsg);
                return;
            }

            holidaySrvc.remove(date.id, function(response) {
                $('.calendar').fullCalendar('removeEvents', date._id);
                notificationSrvc.notification("success", holidayMessagesConst.delete);
            }, function(error) {
                notificationSrvc.notification("error", error.data.detail);
            });
        }
    }
})();
